/**
 * Bepaalt waarom de verzendknop geblokkeerd is, zodat de composer dat kan tonen
 * i.p.v. een grijze knop zonder uitleg. Pure functie — makkelijk te testen en
 * herbruikbaar voor elke module die MassMail gebruikt.
 */
export interface SendBlockInput {
  subject: string;
  content: string;
  /** Ontvangers mét een bruikbaar e-mailadres. */
  validContactCount: number;
  /** Namen van geselecteerde ontvangers zónder e-mailadres. */
  contactsWithoutEmail: string[];
  isTemplateValid: boolean;
}

const MAX_NAMES_IN_MESSAGE = 3;

function formatNames(names: string[]): string {
  const shown = names.slice(0, MAX_NAMES_IN_MESSAGE).join(', ');
  const rest = names.length - MAX_NAMES_IN_MESSAGE;
  return rest > 0 ? `${shown} +${rest} andere` : shown;
}

export function getSendBlockReason(input: SendBlockInput): string | null {
  const { subject, content, validContactCount, contactsWithoutEmail, isTemplateValid } = input;

  if (validContactCount === 0) {
    if (contactsWithoutEmail.length > 0) {
      return `Geen e-mailadres bekend voor ${formatNames(contactsWithoutEmail)} — vul het adres aan bij de contactgegevens`;
    }
    return 'Nog geen ontvanger met e-mailadres geselecteerd';
  }

  if (!subject.trim()) return 'Onderwerp ontbreekt';
  if (!content.trim()) return 'Bericht is nog leeg';
  if (!isTemplateValid) return 'Template is nog niet volledig ingevuld';

  return null;
}
